
<template>
    <div class='content'>
        <div class="container">
            <div class="dataViewBlock" v-if="show">
                <div v-for="(v, index) in pageList" :key="index">
                    <div class="dataView" @click="goDetail(v.id)">
                        <img class="dataViewImg" :src="v.head_image" alt="" />
                        <div class="rightView">
                            <div class="dataViewT1" style="cursor: pointer;">{{ v.announce_title }}</div>
                            <div class="dataViewT2">{{ clearVhtml(v.describe) }}</div>
                            <!-- <div class="dataViewT2" v-html="v.describe"></div> -->
                            <!-- <span>
                                    {{ v.content }}
                                </span> -->
                            <!-- </div> -->
                            <div class="dataViewT3">{{ v.createtime.slice(0, 10).replace(/-/g, '.') }}</div>
                        </div>
                    </div>
                    <div class="line"></div>
                </div>
            </div>
            <!-- <div
                class="dataViewBlock_d"
                v-else
            >
                <div
                    class="name"
                    @click="goF"
                >返回</div>
            </div> -->
            <div style="height:100px;display: flex;align-items: center;justify-content: center;;">
                <pagination v-if="total" :page.sync="page" :pageSize.sync="pageSize" :total="total" @change="pageChange" />
            </div>
        </div>

    </div>
</template>

<script>
import Pagination from '@/components/Pagination.vue'
var myChart;
export default {
    components: { Pagination },
    data() {
        return {
            show: true,
            page: 1,
            pageSize: 10,
            total: 0,
            pageList: [],
        }
    },
    mounted() {
        const query = this.$route.query;
        this.page = +query.page || 1;
        this.pageSize = +query.size || 10;
        this.getPageCtn();
    },
    methods: {
        clearVhtml(a) {
            // 提取纯文本
            const plainText = a.replace(/\n/g, ''); // 去掉换行符
            // console.warn(plainText)
            // 截取前50个字符
            const truncatedText = plainText.substring(0, 50);
            // console.log(truncatedText);
            return truncatedText;
        },
        goDetail(id) {
            this.$router.push('/home/noticeDetail?id=' + id + '&type=1')
        },
        goF() {
            this.show = true
        },
        /** 分页改变 */
        pageChange() {
            this.$router.replace(`/home/new?page=${this.page}&size=${this.pageSize}`);
            this.getPageCtn();
        },
        /** 获取内容 */
        async getPageCtn() {
            this.pageLoading = true;
            try {
                const res = await this.$post('index/announce', {
                    pageNum: this.page,
                    pageSize: this.pageSize,
                })
                this.pageList = res.data.data || [];
                this.total = res.data.total || 0;
            } catch (error) { }
            this.pageLoading = false;
        },
    },
}
</script>

<style lang='scss' scoped>
.content {
    min-height: 100%;
    background: #f5f7f9;

    .container {
        min-height: 100%;
        display: flex;
        flex-direction: column;

        .dataViewBlock {
            margin-top: 64px;

            .line {
                margin: 40px 0;
                width: 100%;
                height: 0px;
                opacity: 0.17;
                border: 1px solid #707070;
            }

            .dataView {
                display: flex;

                .dataViewImg {
                    width: 317px;
                    height: 213px;
                }

                .rightView {
                    margin-left: 60px;

                    .dataViewT1 {
                        // margin-top: 16px;
                        // font-size: 21px;
                        // font-family: PingFang SC, PingFang SC-Bold;
                        // font-weight: 700;
                        // color: #333333;


                        line-height: 35px;
                        font-weight: 500;
                        font-size: 18px;
                        color: #000;
                        -webkit-transition: all .5s ease;
                        transition: all .5s ease;
                    }

                    .dataViewT2 {

                        // height: 50px;
                        // line-height: 25px;
                        font-size: 14px;
                        color: #888;
                        margin: 5px 0 15px 0;
                        overflow: hidden;

                        // line-height: 30px;
                        margin-top: 18px;
                        width: 818px;
                        height: 100px;
                        // font-size: 15px;
                        // font-family: PingFang SC, PingFang SC-Regular;
                        // font-weight: 400;
                        // color: #666666;
                        // line-height: 22px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        //将对象作为弹性伸缩盒子模型显示。
                        display: -webkit-box;
                        // 从上到下垂直排列子元素
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 3;

                        span {
                            font-size: 16px;
                            font-family: PingFang SC, PingFang SC-Regular;
                            font-weight: 400;
                            color: #666666;
                            line-height: 22px;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            //将对象作为弹性伸缩盒子模型显示。
                            display: -webkit-box;
                            // 从上到下垂直排列子元素
                            -webkit-box-orient: vertical;
                            -webkit-line-clamp: 3;
                        }
                    }

                    .dataViewT3 {
                        display: inline-block;
                        line-height: 30px;
                        font-size: 14px;
                        color: #bbb;
                        // padding-left: 25px;

                        margin-top: 10px;
                        // font-size: 16px;
                        // font-family: PingFang SC, PingFang SC-Regular;
                        // font-weight: 400;
                        // color: #999999;
                    }
                }
            }
        }

        .dataViewBlock_d {
            .name {
                cursor: pointer;
                margin: 20px 0 0 0;
                font-size: 24px;
                color: #999999;
            }
        }
    }
}
</style>
